document.addEventListener("DOMContentLoaded", function() {

    const customViewAsElement = document.getElementById("custom-view-as");
    if (customViewAsElement) {

        const darkModeKey = "grid-size";
        const htmlElement = document.querySelector("html");
        const lightModeButton = document.getElementById("grid-size-button");
        const darkModeButton = document.getElementById("grid-size-button2");

        // Function to set active class on buttons
        function setActiveButton(activeButton, inactiveButton) {
            if (activeButton && inactiveButton) {
                activeButton.classList.add("active");
                inactiveButton.classList.remove("active");
            }
        }

        // Initialize mode on page load based on local storage
        const gridSize = window.localStorage.getItem(darkModeKey);
        if (gridSize === "0") { // Light mode
            htmlElement.classList.add("grid-small");
            htmlElement.classList.remove("grid-big");
            setActiveButton(lightModeButton, darkModeButton);
        } else { // Default to dark mode
            htmlElement.classList.add("grid-big");
            htmlElement.classList.remove("grid-small");
            setActiveButton(darkModeButton, lightModeButton);
        }
 
        // Function to enable light mode
        function enableLightMode() {
            window.localStorage.setItem(darkModeKey, "0");
            htmlElement.classList.remove("grid-big");
            htmlElement.classList.add("grid-small");
            setActiveButton(lightModeButton, darkModeButton);
        }

        // Function to enable dark mode
        function enableDarkMode() {
            window.localStorage.setItem(darkModeKey, "1");
            htmlElement.classList.remove("grid-small");
            htmlElement.classList.add("grid-big");
            setActiveButton(darkModeButton, lightModeButton);
        }

        // Add event listeners to buttons for toggling modes
        lightModeButton.addEventListener("click", enableLightMode);
        darkModeButton.addEventListener("click", enableDarkMode);
    }
});
